import React from 'react';

const SimilarArticles = React.lazy(() => import(/* webpackChunkName: "redesign__components__SimilarArticles" */"./SimilarArticles"));
const Taboola = React.lazy(() => import(/* webpackChunkName: "redesign__components__Taboola" */"./Taboola"));

interface ISimilarArticlesWithTaboola {
    ArticleStore: any;
    isDesktop?: boolean;
    isSemi?: boolean;
    analyticsMode: 'only' | 'withArticles';
}

const SimilarArticlesWithTaboola: React.FC<ISimilarArticlesWithTaboola> = ({ ArticleStore, isDesktop, isSemi, analyticsMode }) => {

    return (
        <>
            {analyticsMode !== 'only' && (!isDesktop || isSemi) && <SimilarArticles articles={ArticleStore.similar_articles} />}
            <Taboola displaySimiliarArticles={analyticsMode !== 'only'} />
        </>
    );

};

export default SimilarArticlesWithTaboola